import React, { useEffect, useState } from "react";
import { api } from "services";
import { useNavigate } from "react-router-dom";

const Index = () => {
  const [managers, setManagers] = useState([]);
  var navigate = useNavigate();

  useEffect(() => {
    api.accountManagers().then((res) => {
      setManagers(res);
    });
  }, []);

  const back = () => {
    navigate(-1);
  }

  const ManagerView = ({item}) => (
      <div className="card border-app m-3" style={{ width: "20rem" }}>
        <div className="card-body">
          <div className="card-title">
            <b className="text-secondary">{item.get("name")}</b>
          </div>
          <div className="card-subtitle mb-2 text-app opacity-75">
            {item.get("location")} - {item.get("state")}
          </div>
          <div className="card-text">{item.get("discription")}</div>
          <div>
            <div className="m-2 managercontacts">
              <a
                href={`https://wa.me/${item.get("whatsapp")}`}
                target="_blank"
                className="manageranker"
              >
                <i className="bi bi-telephone m-2"></i>
                {item.get("phone")}
              </a>
            </div>
            <div className="m-2 managercontacts">
              <a
                href={`https://wa.me/${item.get("whatsapp")}`}
                target="_blank"
                className="manageranker"
              >
                <i className="bi bi-whatsapp m-2"></i>
                {item.get("whatsapp")}
              </a>
            </div>
          </div>
          <div>
            <div className="m-2 managercontacts">
              <a
                href={`mailto:${item.get("email")}`}
                target="_blank"
                className="manageranker"
              >
                <i className="bi bi-envelope m-2"></i>{" "}
                {item.get("email")}
              </a>
            </div>
          </div>
        </div>
      </div>
  )

  return (
    <div className="container">
      <div className="row mt-5">
        <div className="col-1">
          <a role="button" className="btn btn-app" onClick={back} title="Back">
            <i className="bi bi-arrow-left"></i>
          </a>
        </div>
        <div className="col-11">
          <h2 className="">Account Managers</h2>
        </div>
      </div>
      
      <hr />
      <div style={{ display: "flex" }} className="mt-5">
        {managers && managers.map((manager, i) => <ManagerView item={manager} />)}
      </div>
    </div>
  );
};

export default Index;
